// components/organisms/BlogCarousel.tsx
import React from 'react';
import Slider from 'react-slick';
import { Button, Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';

interface BlogCarouselProps {
  title: string;
  children: React.ReactNode;
  showArrows?: boolean;
  slidesToShow?: number;
  className?: string;
}

const BlogCarousel: React.FC<BlogCarouselProps> = ({
  title,
  children,
  showArrows = true,
  slidesToShow = 2,
  className = '',
}) => {
  const sliderRef = React.useRef<Slider>(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className={`p-blog_section ${className}`}>
      <div className="p-blog_section_header">
        <Typography.Text extendClasses="fs-24x30" fontweight="600">
          {title}
        </Typography.Text>

        {showArrows && (
          <div className="p-blog_section_action">
            <Button
              variant="text"
              extendClasses="p-blog_section_button fButton fs-16x24"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              <Icon iconName="previous" size="20" />
            </Button>
            <Button
              variant="text"
              extendClasses="p-blog_section_button fButton fs-16x24"
              onClick={() => sliderRef.current?.slickNext()}
            >
              <Icon iconName="next" size="20" />
            </Button>
          </div>
        )}
      </div>

      <Slider ref={sliderRef} {...settings} className="p-blog_section_item">
        {children}
      </Slider>
    </div>
  );
};

export default BlogCarousel;
